"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestedTab = getRequestedTab;
exports.getRequestedTabFromUrl = getRequestedTabFromUrl;
exports.getTabIdx = getTabIdx;
exports.getTabMapping = getTabMapping;
exports.isTab = isTab;
exports.setTabUrlParam = setTabUrlParam;
exports.tabNames = void 0;
var _objectHelpers = require("./object-helpers");
var _globalVariables = require("./global-variables");
const tabNames = {
  SHOP: 'shop',
  SALES: 'sales',
  ABOUT: 'about'
};
exports.tabNames = tabNames;
const tabMapping = {
  [tabNames.SHOP]: 'shopTabIndexes',
  [tabNames.SALES]: 'salesTabIndexes',
  [tabNames.ABOUT]: 'aboutTabIndexes'
};
function getTabIndexFromHash(provided) {
  const hash = provided || document.location.hash;
  if (hash?.indexOf('#tab') === 0) {
    const foundTabIndex = parseInt(
    // Get the tab index only
    hash.replace('#tab', ''));
    const localUrl = buildUpdatedUrl(foundTabIndex);
    window.history.replaceState('', '', localUrl.pathname + localUrl.search);
    return foundTabIndex;
  }
  return undefined;
}
function buildUpdatedUrl(selectedIndex) {
  const localUrl = new URL(document.location.href);
  if (selectedIndex > 0) {
    localUrl.searchParams.set('_tab', selectedIndex);
  } else {
    localUrl.searchParams.delete('_tab');
  }
  return localUrl;
}
function getRequestedTabFromUrl(url) {
  const localUrl = new URL(url);
  const tabQueryParam = localUrl.searchParams.get('_tab');
  return !!tabQueryParam ? +tabQueryParam : getTabIndexFromHash(localUrl.hash) || 0;
}
function getRequestedTab(out) {
  if (typeof document === 'undefined') {
    return +(0, _objectHelpers.get)(out, 'attributes.req.query._tab', 0);
  }
  const tabQueryParam = new URL(document.location.href).searchParams.get('_tab');
  return !!tabQueryParam ? +tabQueryParam : getTabIndexFromHash() || 0;
}
function setTabUrlParam(selectedIndex) {
  const localUrl = buildUpdatedUrl(selectedIndex);
  window.history.pushState('', '', localUrl.href);
}
function getTabMapping(tabName) {
  const globals = (0, _globalVariables.getGlobals)();
  const globalLocation = tabMapping[tabName];
  return !globalLocation ? [] : globals[tabMapping[tabName]] || [];
}
function isTab(tabName, idx) {
  return getTabMapping(tabName).indexOf(`tab${idx}`) !== -1;
}
function getTabIdx(tabName) {
  const tabIdx = getTabMapping(tabName)[0]?.replace('tab', '');
  return tabIdx ? +tabIdx : null;
}